/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Entity types that permissions can apply to.
 */
export type PermissionEntityType =
  (typeof PermissionEntityType)[keyof typeof PermissionEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEntityType = {
  job: 'job',
  folder: 'folder',
  candidate: 'candidate',
  note: 'note',
  note_template: 'note_template',
} as const;
